import React from 'react'
import styled from 'styled-components'
import { SchoolListingGroup } from './SchoolListingGroup'
import { ISchoolListingItemProp } from './SchoolListingGroup/SchoolListingItemProp'

const StyledListingGroups = styled.div``

interface ISchoolListingGroupsProps {
  schoolCoords: Array<number>
  listings: Array<ISchoolListingItemProp>
}

const SchoolListingGroups: React.FC<ISchoolListingGroupsProps> = ({
  schoolCoords,
  listings,
}) => {
  if (!listings || listings.length === 0) {
    return null
  }
  const listingTypes = [
    {
      name: 'academics',
      categories: ['Maths', 'English'],
    },
    {
      name: 'sports',
      categories: [
        'Soccer',
        'Tennis',
        'Basketball',
        'Auskick',
        'MiniRoos',
        'Female AFL',
        'AFL',
        'Swimming Pool',
        'Karate',
        'Gymnastics',
      ],
    },
    {
      name: 'art',
      categories: ['Art Centre', 'Dancing School'],
    },
    {
      name: 'music',
      categories: ['Piano', 'Keyboard', 'Guitar'],
    },
    {
      name: 'publicFacilities',
      categories: ['Library', 'Park'],
    },
    {
      name: 'playCentres',
      categories: ['Play centre'],
    },
  ]
  const listingsByType = {}
  listings.forEach((l) => {
    listingTypes.forEach(({ name, categories }) => {
      for (let i = 0; i < categories.length; i++) {
        const categoryName = categories[i]
        const foundCategory = l.categories.find(
          (c) => c.name?.toLowerCase() === categoryName.toLowerCase()
        )
        if (foundCategory) {
          const remainingCategories = l.categories.filter((c) => {
            return c.id !== foundCategory.id
          })
          listingsByType[name] = listingsByType[name] || []
          listingsByType[name].push({
            ...l,
            categories: [foundCategory].concat(remainingCategories),
          })
          return
        }
      }
    })
  })
  return (
    <StyledListingGroups>
      <SchoolListingGroup
        title="Sports"
        schoolCoords={schoolCoords}
        listings={listingsByType.sports}
      />
      <SchoolListingGroup
        title="Academic"
        schoolCoords={schoolCoords}
        listings={listingsByType.academics}
      />
      <SchoolListingGroup
        title="Art & Dance"
        schoolCoords={schoolCoords}
        listings={listingsByType.art}
      />
      <SchoolListingGroup
        title="Music"
        schoolCoords={schoolCoords}
        listings={listingsByType.music}
      />
      <SchoolListingGroup
        title="Play centres"
        schoolCoords={schoolCoords}
        listings={listingsByType.playCentres}
      />
      <SchoolListingGroup
        title="Public facilities"
        schoolCoords={schoolCoords}
        listings={listingsByType.publicFacilities}
      />
    </StyledListingGroups>
  )
}

export { SchoolListingGroups }
